import { gql } from '@apollo/client';

export const FRAGMENT_SOURCE_AREA_PROCESS = gql`
    fragment sourceAreaProcess on SourceAreaProcess {
        isVisible
    }
`;
